<template>
  <div class="wrapper">
    <p>シミュレーション{{ title }}</p>
    <div class="simulation-container">
      <AppOverlay v-model="isRegistering">
        <AppLoadingSpinner text="シミュレーション登録中..." class="ma-3" />
      </AppOverlay>
      <AppOverlay v-model="isFetchSimulationPoiLocations">
        <AppLoadingSpinner
          text="シミュレーション地点読み込み中..."
          class="ma-3"
        />
      </AppOverlay>
      <div class="main">
        <v-stepper :value="currentStep" class="stepper-header">
          <SimulationModelContentNavigation :form="form" />
          <v-stepper-items class="stepper-content">
            <v-stepper-content
              v-for="(item, index) in steps"
              :key="item.name"
              :step="index + 1"
              :class="[{ deliveryStyle: item.name === 'Delivery' }]"
            >
              <div
                ref="page"
                :is="`SimulationModelContent${item.name}`"
                :form="form"
                v-if="stepInfo.name === item.name"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <!-- footer -->
        <div class="footer">
          <SimulationFooterTemplate
            :form="form"
            @toggleIsRegistering="toggleIsRegistering()"
          />
        </div>
      </div>
      <SimulationResult
        :form="form"
        :isFetchSimulationPoiLocations="isFetchSimulationPoiLocations"
        @toggleIsRegistering="toggleIsRegistering()"
      />
    </div>
  </div>
</template>

<script>
import SimulationFooterTemplate from '@/components/Shared/Simulation/SimulationFooterTemplate'
import { modes } from '@/vuex/modules/simulation/constants'
import { mapActions, mapGetters } from 'vuex'
import SimulationModelContentNavigation from '@/components/Shared/Simulation/SimulationContentNavigation.vue'
import SimulationModelContentBasic from '@/components/Shared/Simulation/SimulationContentBasic.vue'
import SimulationModelContentDelivery from '@/components/Shared/Simulation/SimulationContentDelivery.vue'
import SimulationModelContentAdvanced from '@/components/Shared/Simulation/SimulationContentAdvanced.vue'
import SimulationResult from '@/components/Shared/Simulation/SimulationResult'

export default {
  name: 'SimulationModel',
  /* eslint vue/no-unused-components: 0 */
  components: {
    SimulationResult,
    SimulationFooterTemplate,
    SimulationModelContentNavigation,
    SimulationModelContentBasic,
    SimulationModelContentDelivery,
    SimulationModelContentAdvanced,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isRegistering: false,
      isFetchSimulationPoiLocations: true,
    }
  },
  computed: {
    ...mapGetters('simulation', ['mode', 'currentStep', 'steps']),
    title() {
      const mode = this.mode
      switch (mode) {
        case modes.ADD:
          return '登録'
        case modes.EDIT:
          return '編集'
        case modes.READONLY:
          return '（読み取り専用）'
        default:
          return ''
      }
    },
    stepInfo() {
      return this.steps[this.currentStep - 1]
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
  },
  watch: {
    'form.deliverySetting.menuSetting.simulationPoiLocationGroups': {
      handler() {
        if (
          this.form.deliverySetting.menuSetting.simulationPoiLocationGroups.simulationLocationGroups.filter(
            g => g.simulationLocations.length === 0,
          )
        ) {
          this.isFetchSimulationPoiLocations = false
        }
      },
      deep: true,
    },
  },
  async created() {
    const isLegacySimulation = this.form.isLegacy
    if (
      this.mode === modes.ADD ||
      this.form.deliverySetting.menuSetting.simulationPoiLocationGroups
        .simulationLocationGroups.length === 0
    ) {
      this.isFetchSimulationPoiLocations = false
    }
    if (isLegacySimulation && this.mode === modes.EDIT) {
      if (
        this.userBelongType === 'system owner' ||
        this.userBelongType === 'agency'
      ) {
        await this.$confirm(
          `本シミュレーションは、メニューを再度選択していただく必要がございます。
          代理店マージンを選択の上、メニューを再度ご選択ください。`,
          {
            onlyOk: true,
            okText: '閉じる',
          },
        )
      }

      if (this.userBelongType === 'advertiser') {
        await this.$confirm(
          `本シミュレーションは、メニューを再度選択していただく必要がございます。
          メニューを再度ご選択ください。`,
          {
            onlyOk: true,
            okText: '閉じる',
          },
        )
      }
    }
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    ...mapActions('simulation', {
      reset: 'RESET',
    }),
    toggleIsRegistering() {
      this.isRegistering = !this.isRegistering
    },
  },
}
</script>

<style scoped>
.simulation-container {
  padding: 0;
  display: flex;
  flex-direction: row;
  height: calc(100vh - 140px);
}

.sidebar {
  width: 280px;
}

.main {
  /** 要素のとしての設定 */
  flex-grow: 4;

  /** 親要素のとしての設定 */
  display: flex;
  flex-direction: column;

  /** footerの固定用 */
  position: relative;
}

.stepper-header {
  flex-grow: 1;
}

.footer {
  background-color: #f5f5f5;
  /** footerの固定用 */
  position: absolute;
  bottom: 0;
  width: 100%;
}
.wrapper {
  width: 100%;
}
.stepper-content {
  height: 83%;
  overflow-y: scroll;
}
.deliveryStyle {
  padding: 0;
  height: 100%;
}
</style>
